export default {
  default: () => import("D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/layouts/default.vue").then(m => m.default || m)
}